module.exports = __webpack_public_path__ + "static/media/frutiger-55roman.9b828513.svg";